import type { U3148Affiliation } from "../../../U3148Service";

// Paramètres pour les handlers des actions d'importation d'un usager
export interface U3148UseImportAffiliationHandlersParams<T = any> {
  doImportFn: (orgId: string, affiliation: U3148Affiliation) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Type de retour pour les handlers des actions d'importation d'un usager
export interface U3148UseImportAffiliationHandlersReturn {
  importUser: (orgId: string, affiliation: U3148Affiliation) => void;
}

// Handlers pour les actions d'importation d'un usager
export function useU3148UseImportAffiliaitonHandlers<T extends { id: string } = any>({
  doImportFn,
  onSuccess,
  onError,
}: U3148UseImportAffiliationHandlersParams<T>): U3148UseImportAffiliationHandlersReturn {
  const importUser = async (orgId: string, affiliation: U3148Affiliation) => {
    try {
      const response = await doImportFn(orgId, affiliation);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { importUser };
}
